module.exports = __webpack_public_path__ + "static/media/alvaro.f5e9938b.jpg";